<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div v-show="isOpen" ref="collapsible" :style="containerStyle">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Collapsible",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    enterDuration: {
      type: Number,
      default: 500
    },
    leaveDuration: {
      type: Number,
      default: 300
    },
    enterEasing: {
      type: String,
      default: "ease-in"
    },
    leaveEasing: {
      type: String,
      default: "ease-out"
    },
    direction: {
      type: String,
      default: "vertical",
      validator(value) {
        return ["horizontal", "vertical"].includes(value);
      }
    }
  },
  computed: {
    containerStyle() {
      return this.direction === "horizontal"
        ? "overflow-x: hidden; white-space: nowrap;"
        : "overflow: hidden;";
    }
  },
  methods: {
    beforeEnter(el) {
      if (this.direction === "horizontal") {
        el.style.width = "0";
        el.style.opacity = "0";
      } else {
        el.style.height = "0";
        el.style.opacity = "0";
      }
    },
    enter(el) {
      const dimension = this.direction === "horizontal" ? "width" : "height";
      el.style.transition = `${dimension} ${this.enterDuration}ms ${this.enterEasing}, opacity ${this.enterDuration}ms ${this.enterEasing}`;

      // Ожидаем отрисовки следующего кадра
      requestAnimationFrame(() => {
        el.style[dimension] =
          this.direction === "horizontal"
            ? `${el.scrollWidth}px`
            : `${el.scrollHeight}px`;
        el.style.opacity = "1";
      });
    },
    afterEnter(el) {
      if (this.direction === "horizontal") {
        el.style.width = "auto"; // Устанавливаем `auto` для полной ширины
      } else {
        el.style.height = "auto";
      }
      el.style.transition = "";
    },
    beforeLeave(el) {
      if (this.direction === "horizontal") {
        el.style.width = `${el.scrollWidth}px`; // Фиксируем ширину перед закрытием
        el.style.opacity = "1";
      } else {
        el.style.height = `${el.scrollHeight}px`;
        el.style.opacity = "1";
      }
    },
    leave(el) {
      const dimension = this.direction === "horizontal" ? "width" : "height";
      el.style.transition = `${dimension} ${this.leaveDuration}ms ${this.leaveEasing}, opacity ${this.leaveDuration}ms ${this.leaveEasing}`;

      // Анимация закрытия
      requestAnimationFrame(() => {
        el.style[dimension] = "0";
        el.style.opacity = "0";
      });
    },
    afterLeave(el) {
      el.style.width = "";
      el.style.height = "";
      el.style.transition = "";
    }
  }
};
</script>

<style scoped>
.collapsible-content {
  overflow: hidden;
  transition-property: height, width, opacity;
  white-space: nowrap; /* Предотвращение переноса содержимого для горизонтальной анимации */
}
</style>
